<template>
  <div class="progress-cell">
    <div v-if="params.data.progress.state === 0 && !params.data.progress.activated" class="tag black" v-text="$t('app.campaign.follow.headerButtons.filter.notActivated')" v-tooltip="$t('app.campaign.follow.notActivated.tooltip')" />
    <div v-else-if="params.data.progress.state === 0 && !params.data.progress.isCreated" class="tag grey-light" v-text="$t('app.campaign.follow.headerButtons.filter.accountNotCreated')" v-tooltip="$t('app.campaign.follow.accountNotCreated.tooltip')" />
    <div v-else-if="params.data.progress.state === 0 && params.data.progress.isCreated" class="tag orange" v-text="$t('app.campaign.follow.headerButtons.filter.pendingStart')" v-tooltip="$t('app.campaign.follow.pendingStart.tooltip')" />
    <div v-else-if="params.data.progress.state === 1" class="progress-bar-container" v-tooltip="$t('app.campaign.follow.inProgress.tooltip')">
      <span>{{ params.data.progress.progress || 0 }}%</span>
      <div class="bar">
        <div class="progress" :style="{ width: `${params.data.progress.progress || 0}%` }" />
      </div>
    </div>
    <div v-else-if="params.data.progress.state !== 2" class="tag orange" v-text="$t('app.campaign.follow.calculatingResults.label')" v-tooltip="$t('app.campaign.follow.calculatingResults.tooltip')" />
    <div v-else-if="params.data.progress.state === 2" class="tag green" v-text="$t('app.campaign.follow.headerButtons.filter.availableResults')" />
  </div>
</template>

<script setup lang="ts">
import { ParticipantRow } from '@/types/participant';
import type { ICellRendererParams } from 'ag-grid-community';

const props = defineProps<{
  params: ICellRendererParams<ParticipantRow>, // injected by AG Grid, contains `data`, `api`, etc.
}>();

</script>

<style lang="scss">
@import "@/assets/style/variables.scss";

.progress-cell {
  width: 100%;
  height: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  display: flex;
  align-items: center;
  justify-content: center;

  .tag {
    line-height: normal;
    font-size: 12px !important;
  }
}

.progress-bar-container {

  span {
    line-height: 12px;
  }

  .bar .progress {
    background-color: $blue-color;
  }
}
</style>